// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3gIRU","sendOtp":"AuthorizeToLogin_sendOtp__s5EMx"};